import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PlanSubdirectorySubscriptionTableItem from './PlanSubdirectorySubscriptionTableItem';
import {
  ICompanySubdirectorySubscriptionQueryData,
  ICompanySubdirectorySubscriptionVars,
  useCompanySubdirectorySubscriptionQuery,
} from '../../../../../graphql/query/companySubdirectorySubscription/useCompanySubdirectorySubscriptionQuery';
import GraphQLTable from '../../../../components/_table/GraphQLTable';
import Helmet from '../../../../components/Helmet';
import { ICompanySubdirectorySubscriptionSchema } from '../../../../../graphql/type/companySubdirectorySubscription';
import PlanLayout from '../../../../layout/Plan';
import Context from '../../../../context';
import SelectYesNo from '../../../../components/_select/SelectYesNo';

function PlanSubdirectorySubscriptionTable() {
  const { t } = useTranslation();
  const [tableRefreshKey, setTableRefreshKey] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<
    ICompanySubdirectorySubscriptionSchema[]
  >([]);
  const { company: contextCompany } = useContext(Context);

  return (
    <>
      <Helmet
        title={`${t('subdirectory')} ${t('subscription', { count: 2 })} | ${t(
          'plan'
        )}`}
      />
      <GraphQLTable<
        ICompanySubdirectorySubscriptionQueryData,
        ICompanySubdirectorySubscriptionSchema,
        ICompanySubdirectorySubscriptionVars
      >
        refreshKey={tableRefreshKey}
        select={`
                _id
                company
                status
                expiryDate
                subdirectoryData {
                  _id
                  company
                  companyData {
                    _id
                    name {
                        la
                        text
                    }
                    origin
                    slug
                  }
                 
                  status
                  domain
                }
       	 `}
        useQuery={useCompanySubdirectorySubscriptionQuery}
        renderHeader={[
          {
            field: '_id',
            label: t('id'),
            align: 'left',
            sortable: true,
          },
          {
            field: 'domain',
            label: `${t('subdirectory')} ${t('domain')}`,
            align: 'center',
          },
          {
            field: 'subdirectory_status',
            label: `${t('subdirectory')} ${t('status')}`,
            align: 'center',
          },
          {
            field: 'company',
            label: `${t('subdirectory')} ${t('company')}`,
            align: 'center',
          },
          {
            field: 'subscription_status',
            label: `${t('subscription')} ${t('status')}`,
            align: 'center',
          },
          {
            field: 'expiryDate',
            label: t('expiry_date'),
            align: 'center',
          },
          {
            field: 'action',
            label: t('action'),
            align: 'right',
          },
        ]}
        renderItem={(item) => (
          <PlanSubdirectorySubscriptionTableItem
            item={item}
            setTableRefreshKey={setTableRefreshKey}
          />
        )}
        onItemSelected={setSelectedItems}
        selectedItems={selectedItems}
        filterFields={{
          status: {
            label: `${t('subscription')} ${t('status')}`,
            component: SelectYesNo,
            componentProps: {
              menuPosition: 'fixed',
              isClearable: true,
            },
            onChange: (option) => {
              if (option) {
                if (option.value === true) {
                  return true;
                }
                if (option.value === false) {
                  return false;
                }
              }

              return null;
            },
          },
        }}
        searchFields={{
          _id: { label: t('id') },
        }}
        defaultFilterOptions={{
          companyId: contextCompany._id,
        }}
        title={`${t('subdirectory')} ${t('subscription', { count: 2 })}`}
        defaultSort="createdTime"
        defaultSortOrder={-1}
        actionButtons={[]}
        itemKey="_id"
      />
    </>
  );
}

export default () => (
  <PlanLayout main={<PlanSubdirectorySubscriptionTable />} />
);
